import * as Factory from 'factory.ts'
import faker from 'faker'

import { PaymentMethodTypes } from '@webapp/models/enums'
import {
  type VendorPaymentMethod,
  type VendorPaymentMethodV2,
} from '@webapp/models/VendorPaymentMethod'
import { CurrencyMock } from './currency.factory'

export const VendorPaymentMethodMock =
  Factory.Sync.makeFactory<VendorPaymentMethod>({
    id: Factory.each(() => faker.random.number()),
    vendor: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.company.companyName()),
    type: PaymentMethodTypes.ACH,
    account_holder_name: Factory.each(() => faker.company.companyName()),
    account_number: Factory.each(() => faker.finance.account(12)),
    routing_number: Factory.each(() => faker.finance.account(9)),
    currency: CurrencyMock.build(),
  })

export const VendorPaymentMethodV2Mock =
  Factory.Sync.makeFactory<VendorPaymentMethodV2>({
    id: Factory.each(() => faker.random.number()),
    vendor_id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.company.companyName()),
    type: PaymentMethodTypes.ACH,
    currency_id: CurrencyMock.build().id,
    data: {},
  }).withDerivation1(['type'], 'data', (type) => {
    switch (type) {
      case PaymentMethodTypes.ACH:
        return {
          account_holder_name: faker.company.companyName(),
          account_number: faker.finance.account(12),
          routing_number: faker.finance.account(9),
        }
      case PaymentMethodTypes.EFT:
        return {
          bank_account_holder_name: faker.name.firstName(),
          institution_number: faker.finance.account(3),
          transit_number: faker.finance.account(5),
          account_number: faker.finance.account(9),
          payee_name: faker.company.companyName(),
        }
    }
  })
